export default "<div class=\"example-button-row\">\r\n    <button mat-button color=\"primary\"  (click)=\"downloadExcel()\">Descargar</button>\r\n</div>\r\n";